import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { LoginService } from 'src/app/modules/services/login.service';
import { url } from 'src/app/modules/util/constants';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

  constructor(private router: Router, private fb: FormBuilder, private loginService: LoginService, private messageService: MessageService, @Inject(PLATFORM_ID) private platformId: Object) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('[0-9]+')]],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(20)]]
    });
  }

  loginForm: FormGroup;

  login() {
    if (isPlatformBrowser(this.platformId)) {
      this.messageService.clear();
      let detail: string | undefined = undefined;
      let severity = '';
      this.loginService.login(this.loginForm.value['username'], this.loginForm.value['password']).subscribe(response => {
        if (response.status === 'success') {
          sessionStorage.removeItem('loggedUser');
          sessionStorage.removeItem('auth');
          if (response.data?.active === 1) {
            sessionStorage.setItem('auth', response.token!);
            sessionStorage.setItem('loggedUser', (response.data! as any).urlId);
            if (!response.data.role) {
              this.router.navigate([url['perfil'] + '/' + (response.data! as any).urlId]);
            } else if (response.data.role === 'administrador') {
              sessionStorage.setItem('loggedUser', 'admin');
              this.router.navigate([url['administracion']]);
            }
          } else {
            detail = 'Usuario inactivo.';
            severity = 'error';
          }
        }
        if (!detail){
          detail = response.status === 'success' ? response.data?.userName : response.message;
          severity = response.status;
        }
        this.messageService.add({
          key: 'user',
          severity: severity,
          detail: detail,
        });
      });
    }
  }

  navigateRegister() {
    this.router.navigate([url['registro-1']]);
  }
}
